import { BaseHttpClient } from '@/modules/common/services/http/__deprecated__/base-http-client';
import {
  IExecuteRedemptionRequest,
  IExecuteRedemptionResponse,
  IGetProductsWithdrawResponse,
  IGetTransactionOptionsResponse,
  IRedemptionPreviewPayload,
  IRedemptionPreviewResponse
} from './withdraw-types';

export class BffWithdraw extends BaseHttpClient {
  constructor() {
    super(undefined, process.env.VUE_APP_BFF_INVESTMENTS_URL);
  }

  public getProductsToWithdrawFromPortfolio = (
    portfolioId: string
  ): Promise<IGetProductsWithdrawResponse> => {
    return this.get(`v2/allocationsToRedeem/${portfolioId}`);
  };

  public getPortfolioTransactionOptions = (
    portfolioId: string,
    customerId: string
  ): Promise<IGetTransactionOptionsResponse> => {
    return this.get('v1/getPortfolioTransactionOptions/', {
      params: {
        portfolioId,
        customerId
      }
    });
  };

  public redemptionPreview = (
    data: IRedemptionPreviewPayload
  ): Promise<IRedemptionPreviewResponse> => {
    return this.post('v2/redemptionPreview/', {
      ...data
    });
  };

  public executeRedemption = (
    data: IExecuteRedemptionRequest
  ): Promise<IExecuteRedemptionResponse> => {
    return this.post('v2/executeRedemption/', data);
  };
}
